<template>
	<svg
		width="186"
		height="179"
		viewBox="0 0 186 179"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M151.529 61.1024L104.214 108.417V0H82.2142V108.417L34.8991 61.1024L20 76.0015L93.2142 149.216L166.428 76.0015L151.529 61.1024ZM186 158H0V179H186V158Z"
			fill="black"
		/>
	</svg>

</template>

<script>
export default {
	data() {
		return {};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

